import { Skeleton } from '../../../components/ui';

/** Loading placeholder for the message thread while a session's history is
 *  fetched. Shared by ChatPage and ChatPanel so the session-switch loading
 *  state is identical on both surfaces. */
export function ChatHistorySkeleton() {
  return (
    <div className="flex flex-col gap-4 p-4">
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          className={i % 2 === 0 ? 'self-start w-2/3' : 'self-end w-1/2'}
        >
          <Skeleton variant="text" lines={2} />
        </div>
      ))}
    </div>
  );
}
